<h1 mat-dialog-title>
  {{title}}
</h1>
<div mat-dialog-content>
  <img class="image" [src]="imageUrl">
</div>
<div class="buttons" mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirm()">Close</button>
</div>
